<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>
	   				
	   				<v-text-field v-model="filter.bill_number" label="Bill Number" class="mr-3"></v-text-field>
            
		            <autocomplete v-model="filter.purchase_type" :items="types" label="Type" />

		            <autocomplete v-model="filter.status" :items="statuses" label="Status" />

            		<search-btn @click="filterData" />

            		<v-spacer></v-spacer>
             		<v-btn v-if="hasCreateAccess" to="/purchase" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="purchase-list-item" :item="props.item" @confirm="confirmApproveItem" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelPurchase" />

      <v-dialog v-model="approveDialog" max-width="350px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Approve Purchase</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete v-if="approvingItem && approvingItem.purchase_type == config.purchaseTypes.product" v-model="approvingItem.warehouse" :items="warehouses" item-text="title" item-value="id" label="Warehouse"></v-autocomplete>
          </v-card-text>

          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat small :disabled="processing" @click.prevent="closeApproveDialog">Cancel</v-btn>
            <v-btn color="blue darken-1" flat small :disabled="processing || (approvingItem && approvingItem.purchase_type == config.purchaseTypes.product && !approvingItem.warehouse)" :loading="processing" @click.prevent="approvePurchase">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import PurchaseListItem from './PurchaseListItem'

  export default {
    name: 'PurchaseList',
    data () {
      return {
      	title: "Purchase List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Purchase ID', value: 'code'},
          { text: 'Bill No.', value: 'bill_number'},
          { text: 'Vendor', value: 'vendor'},
          { text: 'Purchase Date', value: 'date'},
          { text: 'Type', value: 'purchase_type'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status' },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        approvingItem: null,
        approveDialog: false,
        cancellingItem: null,
        cancelDialog: false,
        warehouse: [],
        filter: {
          purchase_type: "",
          bill_number: "",
          status: ""
        },
        types: [
          {
            id: "",
            title: "All"
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Purchase',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Purchase')
    },
    methods: {

      loadPage () {

      	let api_path = this.config.apis.getPurchases.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      confirmApproveItem (item) {
        this.approvingItem = item
        this.approveDialog = true
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeApproveDialog () {
        this.approvingItem = null
        this.approveDialog = false
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      approvePurchase () {
        
        if (!this.approvingItem) return

        let data = { warehouse: this.approvingItem.warehouse }

        this.processing = true
        this.axios.put(this.config.apis.approvePurchase.replace(":id", this.approvingItem.id), data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.approvingItem.status = this.config.purchaseStatus.approved

              this.notifySuccess('updateSuccess')
              this.closeApproveDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeApproveDialog()
          })

      },

      cancelPurchase () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelPurchase.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.purchaseStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })
      }

    },
    mounted () {

    	for (const [key, val] of Object.entries(this.config.purchaseTypes)) {
	        this.types.push({id: val, title: key})
	    }

	    for (const [key, val] of Object.entries(this.config.purchaseStatus)) {
	        this.statuses.push({id: val, title: key})
	    }

      	this.getAllData('warehouse')
        	.then((response) => {
          		this.warehouses = response
        	})
    },

    computed: {

    },

    watch: {

    },
    
    components: {
      'purchase-list-item': PurchaseListItem
    }

  }
</script>
